const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/drivers/$driverId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { DRIVER_DETAIL_TABS } from '@/features/fleet-management/driver/model/driver-detail-tab';
import { createSearchValidator } from '@/lib/search-validators';
export const Route = createFileRoute('/_app/fleet-management/drivers/$driverId')({
  // `Record<never, ...>` (not `Record<string, ...>`): this page has no
  // filters, and a `string` index signature here would poison the merged
  // search type with an implicit `[x: string]: never`, breaking the `search:
  // prev => ({ ...prev, tab })` navigate updater below.
  validateSearch: createSearchValidator<Record<never, string | undefined>, DriverDetailTab>({
    tabs: DRIVER_DETAIL_TABS,
    filterKeys: []
  }),
  staticData: {
    breadCrumb: 'Driver Detail'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Not `initials()` from `lib/format`: that one splits a free-text name on
 * whitespace and takes the first two parts, so a two-part first name
 * ("Anna Maria Schmidt") would spend both letters on the first name. The driver
 * record keeps the parts separate, so take one letter from each.
 */